<h2 class="mb-3 text-xl font-bold md:mb-0">Bank Account</h2>

<button
  type="button"
  (click)="showBankAccountDialog()"
  class="mt-5 rounded-md bg-primary-md-dark px-5 py-1 text-white duration-300 ease-in-out hover:-translate-y-1">
  <fa-icon [icon]="faSquarePlus"></fa-icon>
  Add Bank
</button>

<div class="bank-list mt-5 space-y-3">
  <div
    class="bank-item divide-y divide-gray-200 rounded-md border shadow-md"
    *ngFor="let account of bankAccounts">
    <div
      class="bank-card grid cursor-pointer items-center gap-3 p-3 md:flex"
      [ngClass]="{ 'is-inactive': !account.is_active }">
      <div class="title flex-1">
        {{ account.bank_name }}
      </div>
      <div class="subtitle flex-1">No. Rek {{ account.account_no }}</div>
      <div class="subtitle flex-1">{{ account.account_name }}</div>
      <div class="btn-action-wrapper flex items-center justify-end gap-3">
        <button
          class="btn-delete rounded-md border border-primary-darkest py-1 px-3"
          (click)="delete(account.id)">
          <fa-icon [icon]="faTrash"></fa-icon> Hapus
        </button>
        <button
          class="btn-edit rounded-md border border-primary-darkest py-1 px-3"
          (click)="showBankAccountDialog(account)">
          <fa-icon [icon]="faEdit"></fa-icon> Edit
        </button>
      </div>
    </div>
  </div>
</div>
